/**
 * This defines a list of constants identifying the components that would always be built
 * even if the lazyLoading flag is set to true.
 */
define([
    "MW/statusbar/TypeConstants",
    "MW/toolstrip/constants/TypeConstants"
], function (StatusBarTypeConstants, ToolstripTypeConstants) {
    return [
        ToolstripTypeConstants.TOOLSTRIP,
        ToolstripTypeConstants.TAB_GROUP,
        ToolstripTypeConstants.TAB,
        ToolstripTypeConstants.QAB,
        ToolstripTypeConstants.QA_GROUP,
        ToolstripTypeConstants.QAB_PUSH_BUTTON,
        ToolstripTypeConstants.QAB_DROP_DOWN_BUTTON,
        ToolstripTypeConstants.QAB_SPLIT_BUTTON,
        ToolstripTypeConstants.QAB_TOGGLE_BUTTON,
        ToolstripTypeConstants.QAB_TOGGLE_SPLIT_BUTTON,
        ToolstripTypeConstants.QAB_FLOATING_PANE_DOCK,

        ToolstripTypeConstants.POPUP_LIST_HEADER,
        ToolstripTypeConstants.POPUP_LIST_PANEL,

        // TODO: see if we can remove these expections once figure creates the new toolstrip tab.
        // adding the following two expection to solve geck g1877387
        ToolstripTypeConstants.MENUBAR_WRAPPER,
        ToolstripTypeConstants.TOOLBAR_WRAPPER,

        StatusBarTypeConstants.STATUS_BAR_ROOT,
        StatusBarTypeConstants.STATUS_BAR,
        StatusBarTypeConstants.STATUS_GROUP,
        StatusBarTypeConstants.STATUS_LABEL,
        StatusBarTypeConstants.STATUS_PROGRESS_BAR,
        StatusBarTypeConstants.STATUS_PUSH_BUTTON,
        StatusBarTypeConstants.STATUS_TEXT_FIELD,
        StatusBarTypeConstants.STATUS_TOGGLE_BUTTON
    ];
});
